import { render, staticRenderFns } from "./footer-p.vue?vue&type=template&id=19d50966&scoped=true"
import script from "./footer-p.vue?vue&type=script&lang=js"
export * from "./footer-p.vue?vue&type=script&lang=js"
import style0 from "./footer-p.vue?vue&type=style&index=0&id=19d50966&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d50966",
  null
  
)

export default component.exports